import React from 'react';
import { Box, Typography, styled, Paper } from '@mui/material';
import { format, parseISO } from 'date-fns';

const TimelineContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3)
}));

const TimelineItem = styled(Paper)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  background: 'rgba(255, 255, 255, 0.05)',
  borderRadius: theme.spacing(1),
  border: '1px solid rgba(255, 255, 255, 0.1)',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: -theme.spacing(1),
    top: '50%',
    width: theme.spacing(2),
    height: '2px',
    background: '#7C4DFF'
  }
}));

const TimelineDateMarker = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  background: 'rgba(124, 77, 255, 0.2)',
  borderRadius: theme.spacing(1),
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2)
}));

const EventTimelineView = ({ events }) => {
  // Group events by date
  const groupedEvents = events.reduce((acc, event) => {
    const date = format(parseISO(event.startDate), 'yyyy-MM-dd');
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(event);
    return acc;
  }, {});

  return (
    <TimelineContainer>
      {Object.entries(groupedEvents)
        .sort(([dateA], [dateB]) => new Date(dateA) - new Date(dateB))
        .map(([date, dateEvents]) => (
          <Box key={date}>
            <TimelineDateMarker>
              <Typography variant="subtitle1" sx={{ color: '#fff' }}>
                {format(new Date(date), 'MMMM d, yyyy')}
              </Typography>
            </TimelineDateMarker>
            
            {dateEvents.map((event, index) => (
              <TimelineItem key={index} elevation={0}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" sx={{ color: '#fff' }}>
                    {event.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                    {event.description}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, mt: 1, color: 'rgba(255, 255, 255, 0.5)' }}>
                    <Typography variant="caption">
                      {format(parseISO(event.startDate), 'h:mm a')}
                    </Typography>
                    {event.location && (
                      <Typography variant="caption">
                        {event.location}
                      </Typography>
                    )}
                    <Typography variant="caption" sx={{
                      color: getEventTypeColor(event.type)
                    }}>
                      {event.type}
                    </Typography>
                  </Box>
                </Box>
              </TimelineItem>
            ))}
          </Box>
        ))}
    </TimelineContainer>
  );
};

const getEventTypeColor = (type) => {
  switch (type) {
    case 'compliance': return '#00BCD4';
    case 'filing': return '#4CAF50';
    case 'deadline': return '#F44336';
    case 'fundraising': return '#FF9800';
    case 'meeting': return '#9C27B0';
    case 'alert': return '#FFC107';
    default: return '#7C4DFF';
  }
};

export default EventTimelineView; 